import React from 'react';
import { PaymentDetails } from '../../interfaces/user';

interface Props {
  data: PaymentDetails;
  onClose: () => void;
}

const PaymentModal: React.FC<Props> = ({ data, onClose }) => (
  <div className="card mb-2 fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded-xl shadow-2xl w-[30rem]">
      <h2 className="text-xl font-semibold text-center text-red-600 mb-4">⚠️ Payment Details</h2>

      <table className="w-full text-sm border border-gray-300 rounded overflow-hidden">
        <tbody>
          <tr><td className="font-medium p-2">Transaction ID</td><td className="p-2">{data.transactionId}</td></tr>
          <tr><td className="font-medium p-2">Gateway</td><td className="p-2">{data.paymentGateway}</td></tr>
          <tr><td className="font-medium p-2">Amount</td><td className="p-2">₹{data.amount}</td></tr>
          <tr><td className="font-medium p-2">Status</td><td className="p-2">{data.status}</td></tr>
          <tr><td className="font-medium p-2">Date</td><td className="p-2">{new Date(data.date).toLocaleString()}</td></tr>
        </tbody>
      </table>

      <div className="text-center mt-4">
        <button className="px-4 py-2 bg-blue-600 text-white rounded" onClick={onClose}>Close</button>
      </div>
    </div>
  </div>
);

export default PaymentModal;
